<template>
  <div class="mt-4">
    <TopSection :title="$t('sourceMetadata') | capitalize" />

    <!-- TABLE -->
    <v-server-table
      ref="soundRecordingsTable"
      :url="`soundrecordings/${this.$route.params.id}/sources`"
      :columns="soundRecordingColumns"
      :options="options"
    >
      <!-- PROPIETARY ID COLUMN -->
      <template v-slot:proprietary_id="{ row }">
        <div class="table-header pl-1">
          {{ row.proprietary_id }}
        </div>
        <div class="table-sub-class pl-1">
          {{ row.source }}
        </div>
      </template>

      <!-- TITLE COLUMN -->
      <template v-slot:title="{ row }">
        <div class="d-flex flex-column my-1">
          <div class="table-header">
            {{ row.title | capitalize }}
          </div>
          <div class="mb-1">
            <div
              v-for="(metadata, idx) in getMetadata(row, 'title')"
              :key="idx"
              class="table-meta mb-2"
            >
              {{ metadata | capitalize }}
            </div>
          </div>
        </div>
      </template>

      <!-- ARTIST COLUMN -->
      <template v-slot:artist="{ row }">
        <div class="table-header">
          {{ row.artist | capitalize }}
        </div>
        <div class="mb-1">
          <div
            v-for="(metadata, idx) in getMetadata(row, 'artist')"
            :key="idx"
            class="table-meta mb-2"
          >
            {{ metadata.join(", ") }}
          </div>
        </div>
      </template>

      <!-- ISRC COLUMN -->
      <template v-slot:isrc="{ row }">
        <div class="table-main-class">
          {{ row.isrc || '-' | upper }}
        </div>
      </template>

      <!-- LANGUAGE OF PERF COLUMN-->
      <template v-slot:lang_of_perf="{ row }">
        {{ row.lang_of_perf.join(", ") }}
      </template>

      <!-- DURATION COLUMN-->
      <template v-slot:duration="{ row }">
        {{ row.duration | normalizeSeconds }}
      </template>

      <!-- COUNTRIES COLUMN-->
      <template v-slot:fixation_country="{ row }">
        {{ row.fixation_country_name | capitalize }}
      </template>

      <!-- RELEASE NAMES COLUMN-->
      <template v-slot:releaseNames="{ row }">
        <ReleaseNames
          class-names="table-meta mb-2"
          :releases="row.release_names"
        />
      </template>

      <!-- GENRES COLUMN-->
      <template v-slot:genres="{ row }">
        <div
          v-for="(genre, idx) in row.sound_recording.genres"
          :key="idx"
          class="table-sub-class text-sm"
        >
          {{ genre.name }}
        </div>
      </template>

      <!-- INVALIDATE SOURCE-->
      <template v-slot:invalidateSource="{ row }">
        <i v-if="!row.is_sister_society_upload" class="icon fa fa-times col-12 red text-center" @click="invalidate(row)"/>
      </template>
    </v-server-table>


    <!-- Deletion Confirmation -->
    <b-modal
      id="confirmDeletion"
      ref="confirmDeletion"
      :title="$t('invalidateSource') | capitalize"
      hide-footer
    >
      <p>{{ $t("invalidateSourceInfo") }}</p>
      <div class="flex justify-end">
        <action-button
          variant="primary"
          size="big"
          @click="confirmInvalidation()"
        >
          {{ $t("invalidateSource") | capitalize }}
        </action-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { ApiCalls } from "@/assets/libs/services"
import { capitalize } from "lodash"
import { doRequest } from "@/assets/libs/utils"

export default {
  name: "SoundRecordingsTable",

  data () {
    return {
      selectedSoundRecording: {},
      selectedSource: null,
      soundRecordingColumns: [
        "proprietary_id",
        "title",
        "artist",
        "isrc",
        "lang_of_perf",
        "duration",
        "fixation_year",
        "fixation_country",
        "releaseNames",
        "genres",
        "invalidateSource"
      ],
      options: {
        sortable: [],
        headings: {
          proprietary_id: capitalize(this.$t("proprietary_id")),
          title: capitalize(this.$t("title")),
          artist: capitalize(this.$t("artist")),
          isrc: capitalize(this.$t("isrc")),
          lang_of_perf: capitalize(this.$t("lang_of_perf")),
          fixation_country: capitalize(this.$t("fixation_country")),
          releaseNames: capitalize(this.$t("releaseNames")),
          fixation_year: capitalize(this.$t("fixation_year")),
          genres: capitalize(this.$t("genres")),
          invalidateSource: capitalize(this.$t("invalidateSource")),
          actions: ""
        },
        texts: {
          noResults: capitalize(this.$t("placeholderSoundRecording")),
        },
        requestFunction (params) {
          return doRequest(this.url, params)
        },
        responseAdapter: resp => ({
          data: resp.data,
          count: resp.data.length
        })
      }
    }
  },

  methods: {
    getMetadata ({ extras }, tag) {
      if (extras) {
        return extras.reduce((current, next) => {
          if (next.tag === tag) {
            current.push(next.value)
          }
          return current
        }, [])
      }
      return []
    },
    confirmInvalidation () {
      this.loading = true
      return ApiCalls.invalidate(this.selectedSource).then(()=>{
        this.$toasted.global.toast(this.$t("invalidatedSource"))
      })
        .catch(err => {
          this.$toasted.global.toast(err.response.data.detail)
        }).finally(() => {
          this.loading = false
          this.$bvModal.hide("confirmDeletion")
          let table = this.$refs.soundRecordingsTable
          table.refresh()
        })
    },
    invalidate ( row ) {
      this.selectedSource = row.id
      this.$bvModal.show("confirmDeletion")
    },

  },
}
</script>
